module.exports = __webpack_public_path__ + "img/speaker-LeonorRothes.81b33c44.png";